import { InertiaSharedData } from '@/types';
import { usePage } from '@inertiajs/react';

const useInertiaData = () => {
    const { shared } = usePage<InertiaSharedData>().props;
    const { user, csrf_token, messages, is_impersonating, pending_billing_order } = shared as InertiaSharedData;

    return { user, csrf_token, messages, is_impersonating, pending_billing_order };
};

export default useInertiaData;
